import { useEffect } from 'react';
import { useLazyGetOverviewKitQuery } from 'src/services/Overview';
import { useAppDispatch } from 'src/store/hooks';
import { updateUserAccess } from 'src/util/util';

export const useOverview = () => {
  const dispatch = useAppDispatch();

  const [
    getOverviewKitData,
    { isLoading: overviewKitLoading, isError: overviewKitIsError, data: overviewKitData, error: OverviewKitError }
  ] = useLazyGetOverviewKitQuery();

  useEffect(() => {
    if (OverviewKitError) {
      updateUserAccess(OverviewKitError, dispatch);
    }
  }, [OverviewKitError]);

  return {
    getOverviewKitData,
    overviewKitData,
    overviewKitLoading,
    overviewKitIsError
  };
};
